<div class="stravaCard" [class.full]="full">
  <div class="stravaTitle" [style.background]="dark? 'black': 'white'" [style.color]="dark?'white':'black'">
    <div class="titleLabels" *ngIf="full">
      <div id="profile1" class="userSticker">
        <div
          class="profile-picture big-profile-picture"
          [style.backgroundImage]="'url(' + profilePhoto + ')'"
        ></div>
        <img
          *ngIf="athlete?.premium || athlete?.summit"
          class="premium"
          src="/assets/images/premium.png"
        />
      </div>
      <div>
        <p class="name">{{ athlete?.firstname }} {{ athlete?.lastname }}</p>
        <p class="details">
          <img
            *ngIf="activity.type === 'Run'"
            class="activityIcon"
            [style.filter]="dark ? 'invert(1)': 'invert(0)'"
            src="assets/images/activities/run.png"
          />
          <img
            *ngIf="activity.type === 'Ride'"
            class="activityIcon"
            src="assets/images/activities/cycling.png"
          />
          <img
            *ngIf="activity.type === 'Swim'"
            class="activityIcon"
            src="assets/images/activities/swim.png"
          />
          <span class="dateLocation">{{ label }}</span>
        </p>
      </div>
    </div>
    <div class="titleName" *ngIf="showTitle">{{ activity.name }}</div>
    <div class="titleStats">
      <div class="titleSection" *ngIf="activity.distance > 0">
        <div>Distance</div>
        <div class="value">{{ activity.distance | distance }}</div>
      </div>
      <div class="titleBorder" *ngIf="activity.distance > 0"></div>
      <div class="titleSection" *ngIf="activity.distance > 0">
        <div>Pace</div>
        <div class="value">{{ activity.pace | elapsed }}</div>
      </div>
      <div class="titleBorder" *ngIf="activity.distance > 0"></div>
      <div class="titleSection">
        <div>Time</div>
        <div class="value">{{ activity.moving_time | elapsed }}</div>
      </div>
      <div class="lastTitleSection" >
        <div [hidden]="achievements.length === 0">Achievements</div>
        <div class="achievements">
          <ng-container *ngFor="let record of limitedAchievements.slice(0,3)">
            <img
              class="achImage"
              *ngIf="record.type === 'segment_effort_count_leader'"
              src="assets/images/laurel.png"
            />
            <img
              class="achImage"
              *ngIf="record.type === 'overall'"
              [src]="'assets/images/overall_' + record.rank +  '.png'"
            />
            <img
              class="achImage"
              *ngIf="record.type === 'pr'"
              [src]="'assets/images/medal_' + record.rank + '.png'"
            />
          </ng-container>
          <div *ngIf="achievements?.length > 3" class="additional">
            {{ achievements?.length }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--div class="stravaKudos">
    <div class="kudosandcomments">
      <div class="kudos" *ngIf="activity.kudos_count > 0">
        {{ activity.kudos_count }} gave kudos
      </div>
      <div class="comments" *ngIf="activity.comment_count > 1">
        {{ activity.comment_count }} comment{{
          activity.comment_count > 1 ? "s" : ""
        }}
      </div>
    </div>
  </div-->
</div>
